import { emptyPriceInformation, PriceInformation, ProductType } from "./paymentTypes";
import create from "zustand";
import useAuthState from "../../authState";
import defaultPaymentInfoServiceInstance from "../../../provider/paymentInfoService";

interface PaymentCheckoutAboFamilyState {

    priceInformation: PriceInformation,
    calculate: () => void;

    product: ProductType;
    setProduct: (product: ProductType) => void;

}

export const usePaymentCheckoutAboFamilyState = create<PaymentCheckoutAboFamilyState>(
    (set, get) => (
        {
            priceInformation: emptyPriceInformation,
            calculate: () => {

                // currently duo has NO discount
                const product = get().product;

                if (!product) {
                    return;
                }

                const currentUserOverview = useAuthState.getState().currentUserOverview;

                const voucher = defaultPaymentInfoServiceInstance.voucher;


                const calculatedPriceInformation: PriceInformation =
                    defaultPaymentInfoServiceInstance.calculatePriceForProduct(product, undefined, false);

                if (calculatedPriceInformation?.voucherTag?.startsWith("2for1")) {
                    const priceInformation: PriceInformation = {
                        startPrice: product.priceBefore,
                        totalPrice: product.price,
                        discountPrice: product.priceBefore - product.price,
                        discountPercentage: Math.round(product.priceBefore / (product.priceBefore - product.price)),
                        voucherTag: calculatedPriceInformation.voucherTag,
                        voucherStatus: calculatedPriceInformation.voucherStatus,
                        voucherCode: calculatedPriceInformation.voucherCode
                    }

                    set( { priceInformation } );
                } else if (voucher?.giftcard && currentUserOverview?.canRenewAbo) {

                    const info = defaultPaymentInfoServiceInstance.calculatePriceForProduct(product);

                    const priceInformation: PriceInformation = {
                        startPrice: product.price,
                        totalPrice: info.totalPrice,
                        discountPrice: info.discountPrice,
                        discountPercentage: info.discountPercentage,
                        voucherTag: "upgrade",
                        voucherStatus: null
                    };

                    set({priceInformation});

                } else if (currentUserOverview?.upgradePriceReduction > 0) {

                    const priceInformation: PriceInformation = {
                        startPrice: product.price,
                        totalPrice: product.price - currentUserOverview.upgradePriceReduction,
                        discountPrice: currentUserOverview.upgradePriceReduction,
                        discountPercentage: Math.round(product.price / currentUserOverview.upgradePriceReduction),
                        voucherTag: "upgrade",
                        voucherStatus: null
                    };

                    set({priceInformation});

                } else {
                    const priceInformation: PriceInformation = {
                        startPrice: product.priceBefore,
                        totalPrice: product.price,
                        discountPrice: product.priceBefore - product.price,
                        discountPercentage: Math.round( product.priceBefore / (product.priceBefore - product.price) ),
                        voucherTag: null,
                        voucherStatus: null
                    };

                    set( { priceInformation } );
                }

            },

            product: null,
            setProduct: (product) => {
                set( {product } );
                get().calculate();
            }
        }
    )
);
